import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const passwordResetIsSubmittingSelector = createSelector(stateSelector, (state) => state.isSubmitting);
const passwordResetSentSelector = createSelector(stateSelector, (state) => state.sent);
const passwordResetErrorSelector = createSelector(stateSelector, (state) => state.error);

export const PasswordResetSelectors = {
  passwordResetIsSubmittingSelector,
  passwordResetSentSelector,
  passwordResetErrorSelector,
};
